import {JTDSchemaType} from 'ajv/dist/jtd';
import {SignalStoreConfig} from 'src/app/shared/functions/store.functions';
import { ActionState } from './actions.model';

export interface IJWTDecoded {
  iat: number
  exp: number
  userId: number
}

export const JWTschema: JTDSchemaType<IJWTDecoded> = {
  properties: {
    iat: {type: 'int32'},
    exp: {type: 'int32'},
    userId: {type: 'int32'}
  },
}

export interface JWTState {
  token: string,
  IdTokenHint:string, 
  decodedToken: IJWTDecoded,
  refreshToken: string,
  refreshInterval: ReturnType<typeof setInterval> | undefined,
}

export const jwtStateConfig: SignalStoreConfig<JWTState> = {
  initState: {
    token: '',
    decodedToken: {
      iat: 0,
      exp: 0,
      userId: 0,
    },
    refreshInterval: undefined,
  }
}

export const actionStateConfig: SignalStoreConfig<ActionState> = {
  initState: [{


            id: 0,
            name: '',
            label: '',
            color: ''
        
     
  }]
}

